import { useEffect, useState } from "react";
import moment from "moment-timezone";
import { formatUtcOffset } from "@helpers/timezone";

const TICK_INTERVAL_MS = 1000;

const buildTimeString = (timezone) =>
  `${moment.tz(timezone).format("HH:mm:ss")} ${formatUtcOffset(timezone)}`;

/**
 * Returns the current time string formatted as "HH:mm:ss UTC±N" ("UTC+5:30" for half hours)
 * in the given IANA timezone, updated every second.
 *
 * @param {string} timezone IANA timezone string, e.g. "Europe/Kyiv"
 * @returns {string}
 */
const useChartClock = (timezone) => {
  const [timeString, setTimeString] = useState(() => buildTimeString(timezone));

  useEffect(() => {
    setTimeString(buildTimeString(timezone));

    const interval = setInterval(() => {
      setTimeString(buildTimeString(timezone));
    }, TICK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [timezone]);

  return timeString;
};

export default useChartClock;
